import * as ko from "knockout";
import Bao from "./../services/bao-service";
import SearchPaging from "./../factories/search-paging";
import BaoDialog from "./../factories/bao-dialog";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import "./../bindings/bao-number-box";
function PriorityViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.InfoLevelText = ko.pureComputed({
        read: function () {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return self.InfoLevel1();
                case 2:
                    return self.InfoLevel2();
                case 3:
                    return self.InfoLevel3();
                case 4:
                    return self.InfoLevel4();
                case 5:
                    return self.InfoLevel5();
            }
        },
        write: function (value) {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    self.InfoLevel1(value);
                    break;
                case 2:
                    self.InfoLevel2(value);
                    break;
                case 3:
                    self.InfoLevel3(value);
                    break;
                case 4:
                    self.InfoLevel4(value);
                    break;
                case 5:
                    self.InfoLevel5(value);
                    break;
            }
        }
    });
    self.InfoLevel1 = ko.observable();
    self.InfoLevel2 = ko.observable();
    self.InfoLevel3 = ko.observable();
    self.InfoLevel4 = ko.observable();
    self.InfoLevel5 = ko.observable();
    self.Translate = function () {
        var translateDialog = new TranslateDialogViewModel(self.InfoLevel1, self.InfoLevel2, self.InfoLevel3, self.InfoLevel4, self.InfoLevel5);
        translateDialog.Open().then(function () { });
    };
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.InfoLevelText())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(PriorityViewModel, SearchPaging);
PriorityViewModel.prototype.PrimaryKey = "InfoLevelId";
PriorityViewModel.prototype.RefreshUrl = "Priority/Get";
PriorityViewModel.prototype.SaveUrl = "Priority/Save";
PriorityViewModel.prototype.DeleteUrl = "Priority/Delete";
PriorityViewModel.prototype.IsInUseUrl = "Priority/IsInUse";
PriorityViewModel.prototype.PermissionForward = "PriorityForward";
PriorityViewModel.prototype.PermissionBackward = "PriorityBackward";
PriorityViewModel.prototype.PermissionSave = "PrioritySave";
PriorityViewModel.prototype.PermissionRefresh = "PriorityRefresh";
PriorityViewModel.prototype.PermissionDelete = "PriorityDelete";
export default PriorityViewModel;